import React from 'react';
import CardModule from './CardModule';
import inflectionAI from '../assets/Articles/Inflection AI.png';
import linkedin from '../assets/Articles/Linkedin.png';
import claudeDesign from '../assets/Articles/ClaudeDesign.svg';
import contextTransfer from '../assets/Articles/ContextTransfer.svg';
import outreachBot from '../assets/Articles/OutreachBot.svg';
import claudeInChrome from '../assets/Articles/ClaudeInChrome.svg';
import agentTerms from '../assets/Articles/AgentTerms.svg';
import linkedInPills from '../assets/Articles/LinkedInPills.svg';

const Articles = () => {
  const articleCards = [
    {
      title: "I tried to get past LinkedIn's dark patterns, and here is how far I got",
      description: "A job card says \"be an early applicant.\" The click reveals the listing was reposted and over 100 people got there first. Five months of running a Chrome extension that puts the real posting date, duplicate listings and already-applied history back onto the card — and the limit of relabelling what arrives when you can't touch the ordering itself.",
      image: linkedInPills,
      link: "https://medium.com/design-bootcamp/i-tried-to-get-past-linkedins-dark-patterns-and-here-is-how-far-i-got-ffbfa6d70699",
      external: true,
      date: "Oct 2026",
      category: "Medium • 7 min read"
    },
    {
      title: "Businesses, be cautious: your terms of service say \"no automation.\" Is the user really complying?",
      description: "I used an agent to do something a directory site's terms forbid, and the site had no way of knowing. Sitting in the product designer's chair: why agent detection is rented rather than owned, what the ad-blocking decade already taught us about walls, and why metering the behaviour beats blocking it.",
      image: agentTerms,
      link: "https://medium.com/design-bootcamp/businesses-be-cautious-your-terms-of-service-say-no-automation-is-the-user-really-complying-bb69f35fabd5",
      external: true,
      date: "Oct 2026",
      category: "Medium • 13 min read"
    },
    {
      title: "Why can't I see what Claude is doing inside my Chrome browser?",
      description: "Claude in Chrome puts an orange border on the page when the agent takes the wheel, but the step-by-step status lives in the side panel — so on a single laptop screen you choose between watching what's happening and understanding it. A case for docking the status line where the action is.",
      image: claudeInChrome,
      link: "https://medium.com/design-bootcamp/why-cant-i-see-what-claude-is-doing-inside-my-chrome-browser-6c6326214121",
      external: true,
      date: "Sep 2026",
      category: "Medium • 5 min read"
    },
    {
      title: "I built a job-outreach bot to do the boring 80% of cold emailing",
      description: "On building an automation that handles the tedious preliminary work of cold outreach — company research, contact discovery, and email drafting — while keeping a human in the loop on the final 20% that actually matters: the send.",
      image: outreachBot,
      link: "https://medium.com/design-bootcamp/i-built-a-job-outreach-bot-to-do-the-boring-80-of-cold-emailing-045a3e0a101c",
      external: true,
      date: "May 2026",
      category: "Medium • 9 min read"
    },
    {
      title: "Context Transfer Is the New Knowledge Transfer",
      description: "Why AI products need an \"Export context\" feature — exploring how conversation context and reasoning chains are trapped inside individual chat sessions, and what it would take to move them between devices, models, and people.",
      image: contextTransfer,
      link: "https://medium.com/@mchidrupa/context-transfer-is-the-new-knowledge-transfer-5ce1fdb0c2b2",
      external: true,
      date: "Apr 2026",
      category: "Medium • 5 min read"
    },
    {
      title: "The Obvious Next Step for Claude Design",
      description: "An exploration of how AI design tools are compressing the design-to-prototype cycle, and why designers should focus on building the next generation of tools rather than resisting automation.",
      image: claudeDesign,
      link: "https://medium.com/p/0ad6df7931c3",
      external: true,
      date: "Apr 2026",
      category: "Medium • 3 min read"
    },
    {
      title: "Inflection AI Pi Chatbot Redesign: Quick Fixes",
      description: "A comprehensive analysis of the Inflection AI Pi chatbot interface, identifying key UX issues and proposing practical redesign solutions to improve user experience and engagement.",
      image: inflectionAI,
      link: "https://medium.com/design-bootcamp/inflection-ai-pi-chatbot-redesign-quick-fixes-5d63ebf36d30",
      external: true,
      date: "Dec 2023",
      category: "Medium • 5 min read"
    },
    {
      title: "Why is the application process on LinkedIn so overwhelming?",
      description: "An analysis of LinkedIn's job application process from a UX perspective, exploring how user emotions and journey mapping can help identify pain points in the Research, Apply, Connect, and Track phases of job searching.",
      image: linkedin,
      link: "https://medium.com/design-bootcamp/why-is-the-application-process-on-linkedin-so-overwhelming-bde464b3c97f",
      external: true,
      date: "Jul 2023",
      category: "Medium • 2 min read"
    }
  ];

  return (
    <div className="tab-content">
      <CardModule cards={articleCards} />
    </div>
  );
};

export default Articles; 